import { createStore, applyMiddleware, compose, thunk} from 'external/react'
import root from 'components/Uploads/redux'

const middleware = [thunk]
const composeEnchancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(root, composeEnchancers(applyMiddleware(...middleware)))

export default store
